import apiClient from '../client';
import type {
  LoginRequest,
  LoginResponse,
  TokensInfo,
  RefreshTokenRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  ResetPasswordTokenRequest,
  VerifyTwoFactorRequest,
} from '../types/auth';

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>('/auth/login', data),

  refreshToken: (data: RefreshTokenRequest) =>
    apiClient.post<TokensInfo>('/auth/refresh-token', data),

  forgotPassword: (data: ForgotPasswordRequest) =>
    apiClient.post<void>('/auth/forgot-password', data),

  resetPassword: (data: ResetPasswordRequest) =>
    apiClient.post<void>('/auth/reset-password', data),

  validateResetToken: (data: ResetPasswordTokenRequest) =>
    apiClient.post<boolean>('/auth/reset-password-token', data),

  verifyTwoFactor: (data: VerifyTwoFactorRequest) =>
    apiClient.post<TokensInfo>('/auth/verify-2fa', data),

  setupTwoFactor: () =>
    apiClient.post<{ otpauthUri: string }>('/auth/setup-2fa'),

  confirmTwoFactor: (code: string) =>
    apiClient.post<void>('/auth/confirm-2fa', { code }),

  disableTwoFactor: () =>
    apiClient.delete<void>('/auth/2fa'),
};
